import { Injectable, Provider, Type } from '@angular/core';
import { VaultApiService } from '@app/core/services/api/vault-api.service';
import { CompanyScopeHeadersService } from './company-scope-headers.service';

/**
 * Versão "sem escopo" do serviço de escopo (card 3298): não devolve o header `X-CUSTOM-COMPANIES`.
 *
 * Não é provida no root. Entra só pelos `providers` de um componente (via
 * {@link provideUnscopedCompanyScope}), e vale só para a subárvore dele. É assim que as abas
 * Documentos e Análise econômica da tela do deal mostram a empresa do deal mesmo quando ela está fora
 * do escopo escolhido pelo TENANT, enquanto o menu, as notificações e as outras telas continuam com o
 * escopo (decisão do Victor na proposta do acervo, 05/10/2026).
 *
 * Segurança: o header só existe para TENANT, e para TENANT ele só estreita o que o servidor já libera
 * (todas as empresas do próprio tenant). PARTNER e COMPANY têm o acesso calculado no servidor
 * (`CompanyResolverMiddleware`), então para eles nada muda.
 */
@Injectable()
export class UnscopedCompanyScopeHeadersService extends CompanyScopeHeadersService {
  override readonly isUnscoped = true;

  override async getHeaders(): Promise<Record<string, string>> {
    return {};
  }
}

/**
 * Providers para um componente cuja subárvore deve ignorar o escopo de empresas.
 *
 * ⚠️ Passe TODOS os serviços HTTP usados dentro da subárvore. Eles são `providedIn: 'root'`, e uma
 * instância root pega o `VaultApiService` do root, que obedece ao escopo: o serviço esquecido continua
 * filtrando e aquele pedaço da tela volta vazio para empresa fora do escopo. Serviço com estado
 * compartilhado com o resto do app (menu, notificações, toasts) não entra aqui.
 */
export function provideUnscopedCompanyScope(services: Type<unknown>[]): Provider[] {
  return [
    { provide: CompanyScopeHeadersService, useClass: UnscopedCompanyScopeHeadersService },
    VaultApiService,
    ...services,
  ];
}
